export default {"src":"/_next/static/media/aiavatar-1.693a82e5.svg","height":64,"width":72,"blurWidth":0,"blurHeight":0};